(() => {
  const selector = '[data-lcb-language]';
  function init(scope = document) {
    scope.querySelectorAll(selector).forEach(details => {
      if (details.dataset.languageReady) return;
      details.dataset.languageReady = 'true';
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        document.querySelectorAll(selector).forEach(other => {
          if (other !== details) other.open = false;
        });
      });
      details.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || !details.open) return;
        event.preventDefault();
        event.stopPropagation();
        details.open = false;
        details.querySelector('summary').focus();
      });
      details.querySelector('form').addEventListener('submit', event => {
        const input = event.currentTarget.querySelector('input[name="return_to"]');
        if (input) input.value = location.pathname + location.search + location.hash;
      });
    });
  }
  document.addEventListener('click', event => {
    document.querySelectorAll(selector).forEach(details => {
      if (details.open && !details.contains(event.target)) details.open = false;
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
